export const LOGO = "https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";
export const USER = "https://static.vecteezy.com/system/resources/previews/020/336/373/original/netflix-logo-netflix-icon-free-free-vector.jpg";

export const API_OPTIONS = {
    method: 'GET',
    headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIwZTZlN2ZlYTljYTM5NjBlMTU4OGQ3ZGQyZTI0YjFkYiIsInN1YiI6IjY2M2Y0M2QyZTQ2NmQyMDg3NGI0ZDdjYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.hH_cm4K-lFzXawLwukvDT708e4M8Fd8WvmDc34FrtwE'
    }
};

export const IMG_CDN_URL = 'https://image.tmdb.org/t/p/w500/';

export const BG_URL = "https://assets.nflxext.com/ffe/siteui/vlv3/c7f07b68-7989-4ff7-a31e-11c17dcc2fea/fcf685b8-3f9f-42d8-9af3-4bb86fa5a3b8/IN-en-20240422-popsignuptwoweeks-perspective_alpha_website_large.jpg";

export const SUPPORTED_LANGUAGES =
    [{ identifier: "en", name: "English" },
    { identifier: "hindi", name: "Hindi" },
    { identifier: "spanish", name: "Spanish" },
    ]

export const OPENAI_KEY = 'sk-proj-DokJCE8x66ddEzJIwqUmT3BlbkFJfpnTrG4WcT18u0WZ4P6R';

